import axios from 'axios';

export const MAIN_URL = 'https://www.karusel-tv.ru/video-postcard-2025/api';
export const POST_POSTCARD = 'post';
export const GET_POSTCARD = 'video?token='

interface ISendPoscardResponse {
    readonly success: boolean;
    readonly token: string;
}

interface IGetVideoResponse {
   readonly result: string;
   readonly video: string;
   readonly download: string;
}


export const sendPostcard = async (images: string[]): Promise<ISendPoscardResponse> => {
    const formData = new FormData();

    images.forEach((image) => {
        const byteCharacters = atob(image.split(',')[1]);
        const byteNumbers = new Uint8Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const blob = new Blob([byteNumbers], { type: 'image/png' });
        formData.append('pictures[]', blob, `postcard_${Date.now()}.png`); 
    });

    try {
        const response = await axios.post(`${MAIN_URL}/${POST_POSTCARD}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        console.log('Успешно отправлено:', response.data);
        return response.data;
    } catch (error) {
        console.error('Ошибка отправки открытки:', error);
        throw new Error('Ошибка отправки открытки');
    }
};

// export const sendPostcard = async (images: string[]): Promise<ISendPoscardResponse> => {
//     const formData = new FormData();

//     images.forEach((image, index) => {
//         const byteCharacters = atob(image.split(',')[1]); // Извлекаем Base64 и декодируем
//         const byteNumbers = new Uint8Array(byteCharacters.length);
//         for (let i = 0; i < byteCharacters.length; i++) {
//             byteNumbers[i] = byteCharacters.charCodeAt(i);
//         }
//         const blob = new Blob([byteNumbers], { type: 'image/png' });

//         formData.append(`image${index}`, blob, `postcard_${index}.png`);
//     });

//     try {
//         const response = await axios.post(`${MAIN_URL}/${POST_POSTCARD}`, formData, {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//         });

//         console.log('Успешно отправлено:', response.data);
//         return response.data;
//     } catch (error) {
//         console.error('Ошибка отправки открытки:', error);
//         throw new Error('Ошибка отправки открытки');
//     }
// };

export const getPostcard = async(token: string): Promise<IGetVideoResponse> => {
    try {
        const { data } = await axios.get(`${MAIN_URL}/${GET_POSTCARD}${token}`)
        return data
    } catch {
        throw new Error('Ошибка в получении карточки')
    }
}

export const mockSendPostcard = async (images: string[]): Promise<ISendPoscardResponse> => {

    const token = 'asc13qacsfDASREQWRCZ12341szbsqew' 

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                success: true,
                token: token,
            });
        }, 1000); 
    });
};


// Мок-функция для получения видео
export const mockGetVideo = async (token: string): Promise<IGetVideoResponse> => {

    if (token.length !== 32) {
        throw new Error('Неверный токен');
    }

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                result: 'done',
                video: 'https://www.youtube.com/watch?v=rkRFBZprcgA', // Вставить сюда видео(желательно локальное)
                download: "https://static.karusel-tv.ru/video-postcard-2025-dl/1ivk739vds05h3b7c65nf8840lqcvotw.mp4"
            });
        }, 1000); 
    });
};
